import { useQuery, UseQueryResult } from 'react-query';
import { fetchMorningCommentaries } from '../../services/articles/articles.service';
import { Article, Region } from '../../models';

export default (region: Region, take: number): UseQueryResult<Article[], Error> => {
  return useQuery<Article[], Error>(['fetchMorningCommentaries', region, take], async () =>
    fetchMorningCommentaries(region, take)
  );
};
